
interface TypeCallQueue {
  execute: () => void;
  cancel: () => void;
}


export function concurrencyLimiter(fn, limit) {
  let activeCalls = 0;
  const callQueue:TypeCallQueue[] = [];

  // decrement count and trigger next call
  const next = () => {
    activeCalls--;
    dispatch();
  }

  // add function to queue
  const addToQueue = (params, resolve, reject) => {
    callQueue.push({
      execute: () => {
      // dispatch next in queue on success or on error
      fn(...params).then((res)=> {
        resolve(res);
        next();
      }).catch((err) => {
        reject(err);
        next();
      });
    },
    cancel: () => {
      reject('cancelled');
    }
    });
  };

  // if within limit trigger next from queue
  const dispatch = () => {
    if(activeCalls < limit) {
      const entry = callQueue.shift();
      if (entry) {
        entry.execute();
        activeCalls++;
      }
    }
  }

  // reject pending calls
  const clearQueue = () => {
    while(callQueue.length > 0) {
      const entry = callQueue.pop();
      if(entry) {
        entry.cancel();
      }
    }
  }

  // adds function call to queue
  // calls dispatch to process queue
  const returnFn = (...params) => {
    const res = new Promise((resolve, reject)=> {
      addToQueue(params, resolve, reject);
    });
    dispatch();
    return res;
  }
  returnFn.clearQueue = clearQueue;

  return returnFn;
}
